import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import "./MobileCarousel.scss";
import Countdown from "react-countdown";
import { BsFillStarFill, BsCartPlus } from "react-icons/bs";
import { TiDeleteOutline } from "react-icons/ti";
import { FreeMode, Thumbs } from "swiper";
import { addCommas } from "@persian-tools/persian-tools";
import { useEffect } from "react";
import EditProductAdmin from "../../../SingleProduct/EditProductAdmin.jsx";

const MobileCarousel = ({
  // discountedItems,
  firstProduct,
  productDetail,
  sameProduct,
  selectedProduct,
  productType,
  addCartItem,
  mainAdmin,
}) => {
  // const [selected, setSelected] = useState(discountedItems[0]);
  const [selected, setSelected] = useState(firstProduct);
  const [rangeId, setRangeId] = useState(-1);
  const [productInfo, setProductInfo] = useState({
    business: {},
    product: [
      { bodytxt: "", url: "", title: "", rating_count: "", avg_rating: "" },
    ],
    renge: [
      { to_count: "", from_count: "", to_price: "", from_price: "" },
      { to_count: "", from_count: "", to_price: "", from_price: "" },
      { to_count: "", from_count: "", to_price: "", from_price: "" },
    ],
  });

  const handleItem = (item) => {
    setSelected(item);
  };
  const rangeHandler = () => {
    let priceRange;
    for (let i = 0; i < productDetail.renge.length; i++) {
      if (productDetail.renge[i].is_active == "1") {
        priceRange = productDetail.renge[i].from_price;
      }
    }
    return addCommas(priceRange);
  };
  useEffect(() => {
    setProductInfo(productDetail);
    for (let i = 0; i < productDetail.renge.length; i++) {
      if (productDetail.renge[i].is_active == "1") {
        setRangeId(productDetail.renge[i].id);
      }
    }
  }, [productDetail]);
  console.log("productInfo", productInfo);
  console.log("productDetail", productDetail);
  // console.log("mobileSame", sameProduct);
  return (
    <>
      {/* <div className="d-flex flex-wrap m-2 align-items-center">
        <EditProductAdmin productDetail={productDetail} /> */}
      {/* <div style={{ width: "180px" }} className="mx-1">
          <button className="btn bg-danger mx-1 my-2 text-light danger-button w-100">
            <TiDeleteOutline className="mx-1" />
            حذف محصول
          </button>
        </div> */}
      {/* </div> */}

      <>
        <div className="mobile-carousel-wrapper mt-2">
          <div className="d-flex justify-content-between align-items-start gap-2">
            <div className="right-side d-flex justify-content-center align-items-center flex-column">
              <div className="mobile-image-wrapper">
                <img
                  className=""
                  style={{ borderRadius: "30%" }}
                  src={`http://marketgroup.tatdemo.ir/${productInfo.product[0].url}`}
                />
              </div>
              <div className="mobile-carousel-title fs-6 text-center text-white">
                {/* {selected.title} */}
                {productInfo.product[0].title}
              </div>
              <div className="d-flex justify-content-end align-items-center my-2 gap-1 mt-3 rate text-white">
                <span> ({productDetail.product[0].rating_count})</span>
                <span>{productDetail.product[0].avg_rating}</span>
                <i className="score-icon d-flex justify-content-center align-items-center">
                  <BsFillStarFill color="gold" />
                </i>
              </div>
              <div
                className="d-flex justify-content-center align-items-center mt-3"
                style={{ color: "white" }}
              >
                {/* <Countdown date={selected.countdown} daysInHours={true} /> */}
                {/* {Date.now() < productDetail.main_discount_endtime * 1000 && (
                  <Countdown
                    date={
                      productDetail.renge.length == 0
                        ? productDetail.main_discount_endtime * 1000
                        : productDetail.group_sale_endtime
                    }
                  />
                )} */}

                {productType == 1 &&
                  Date.now() < productInfo.main_discount_endtime * 1000 && (
                    <Countdown
                      date={productInfo.main_discount_endtime * 1000}
                    />
                  )}
                {productType == 2 &&
                  Date.now() < productInfo.group_sale_endtime * 1000 && (
                    <Countdown date={productInfo.group_sale_endtime * 1000} />
                  )}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            {!mainAdmin && productType == 1 && (
              // ((productType == 1 &&
              //   Date.now() < productDetail.main_discount_endtime * 1000) ||
              //   (productType == 1 &&
              //     (productDetail.main_discount_endtime == "0" ||
              //       productDetail.main_discount_endtime == ""))) &&
              <button
                className={`selected-button d-flex justify-content-center align-self-center align-items-center mt-1  text-light `}
                style={{ width: "max-content" }}
                onClick={() => {
                  // let group = productDetail.renge.length > 0 ? 1 : 0;
                  // let group = productType == 2 ? 1 : 0;
                  let group = productType == 2 ? 1 : 0;

                  // let sale =
                  //   // productDetail.renge.length > 0
                  //   productType == 2 ? rangeId : productDetail.id;
                  addCartItem(
                    productDetail.product_id,
                    productDetail.id,
                    group,
                    productDetail
                  );
                }}
              >
                <BsCartPlus className="mx-1" />
                افزودن به سبد خرید
              </button>
            )}
            {!mainAdmin &&
              (rangeId == -1 && productType == 2 ? (
                // Date.now() > productDetail.group_sale_endtime
                <p
                  style={{ fontSize: "13px" }}
                  className="text-white border-bottom border-white"
                >
                  {" "}
                  شرایط فروش گروهی این محصول فعال نیست.
                </p>
              ) : Date.now() < productDetail.group_sale_endtime * 1000 &&
                // ||
                //     productDetail.group_sale_endtime == "0" ||
                //     productDetail.group_sale_endtime == ""
                productType == 2 ? (
                <button
                  className={`selected-button d-flex justify-content-center align-self-center align-items-center mt-1  text-light `}
                  style={{ width: "max-content" }}
                  onClick={() => {
                    // let group = productDetail.renge.length > 0 ? 1 : 0;
                    let group = productType == 2 ? 1 : 0;

                    let sale =
                      // productDetail.renge.length > 0
                      productType == 2 ? rangeId : productDetail.id;
                    addCartItem(
                      productDetail.product_id,
                      sale,
                      group,
                      productDetail
                    );
                  }}
                >
                  <BsCartPlus className="mx-1" />
                  افزودن به سبد خرید
                </button>
              ) : (
                productType == 2 && (
                  <p className="text-white" style={{ fontSize: "12px" }}>
                    زمان فروش گروهی به پایان رسیده است.
                  </p>
                )
              ))}
          </div>
        </div>
        <div className="left-side mt-3 d-flex flex-column justify-content-center align-items-center gap-2">
          <div className="d-flex justify-content-between align-items-center price">
            <div className="d-flex justify-content-center align-items-center ">
              <span className="fw-bold">قیمت : </span>
              {productType == 1 && (
                <span
                  className={`${
                    // ((productDetail.renge.length == 0 &&
                    //   productDetail.main_discount > 0) ||
                    //   productDetail.renge.length > 0) &&
                    productDetail.main_discount > 0 &&
                    Date.now() < productDetail.main_discount_endtime * 1000 &&
                    "text-decoration-line-through"
                  } text-black px-2 fw-bold real-price`}
                >
                  {/* {addCommas(selected.price)} */}
                  {addCommas(productDetail.main_price)} تومان
                </span>
              )}
            </div>
            <div>
              {/* <span className="reduced-price fw-bold">
                {selected.sold <= 100
                  ? addCommas(selected.price - selected.price * 0.25)
                  : selected.sold <= 200 && selected.sold > 100
                  ? addCommas(selected.price - selected.price * 0.5)
                  : selected.sold > 200 &&
                    addCommas(selected.price - selected.price * 0.5)}
              </span> */}
              {/* <span className="reduced-price fw-bold"> تومان</span> */}
              {
                // productDetail.renge.length == 0
                productType == 1 &&
                  productDetail.main_discount > 0 &&
                  Date.now() < productDetail.main_discount_endtime * 1000 && (
                    <div>
                      <span className="reduced-price fw-bold">
                        {addCommas(
                          productDetail.main_price - productDetail.main_discount
                        )}
                        {/* {selected.sold <= 100
                      ? addCommas(selected.price - selected.price * 0.25)
                      : selected.sold <= 200 && selected.sold > 100
                      ? addCommas(selected.price - selected.price * 0.5)
                      : selected.sold > 200 &&
                        addCommas(selected.price - selected.price * 0.5)} */}
                      </span>
                      <span className="reduced-price"> تومان</span>
                    </div>
                  )
              }
              {
                // productDetail.renge.length > 0
                productType == 2 && (
                  <div>
                    <span className="reduced-price fw-bold">
                      {rangeHandler()}
                      {/* {productDetail.renge[0].is_active == "1"
                      ? addCommas(productDetail.renge[0].from_price)
                      : productDetail.renge[1].is_active == "1"
                      ? addCommas(productDetail.renge[1].from_price)
                      : productDetail.renge[2].is_active == "1"
                      ? addCommas(productDetail.renge[1].from_price)
                      : "-"} */}
                      {/* {selected.sold <= 100
                      ? addCommas(selected.price - selected.price * 0.25)
                      : selected.sold <= 200 && selected.sold > 100
                      ? addCommas(selected.price - selected.price * 0.5)
                      : selected.sold > 200 &&
                        addCommas(selected.price - selected.price * 0.5)} */}
                    </span>
                    <span className="reduced-price"> تومان</span>
                  </div>
                )
              }
            </div>
          </div>
          {
            // productDetail.renge.length > 0
            productType == 2 && (
              <div className="w-75">
                {/* first range */}
                {productDetail.renge.length > 0 && productType == 2 && (
                  <>
                    <div
                      className={`sold-count d-flex justify-content-between align-items-center mt-1 mt-md-4 ${
                        // productDetail.renge[0].saled_count >=
                        //   productDetail.renge[0].from_count &&
                        // productDetail.renge[0].saled_count <
                        //   productDetail.renge[0].to_count
                        +productDetail.renge[0].saled_count <
                        +productDetail.renge[0].to_count -
                          +productDetail.renge[0].from_count +
                          1
                          ? "active-progress_active"
                          : "opacity-50"
                      }`}
                    >
                      <span>({productDetail.renge[0].to_count})</span>
                      <span>({productDetail.renge[0].from_count})</span>
                    </div>
                    <div
                      dir="ltr"
                      // style={{ backgroundColor: "#fff" }}
                      className="progress my-1"
                    >
                      <div
                        dir="ltr"
                        id="progress-bar"
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${
                            // selected.sold <= 100 ? selected.sold : 0
                            (productDetail.renge[0].saled_count /
                              productDetail.renge[0].to_count) *
                            100
                          }% `,
                        }}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                        {productDetail.renge[0].saled_count}
                        {/* {selected.sold} */}
                      </div>
                    </div>
                    <div
                      className={`d-flex justify-content-between align-items-center 
                    ${
                      // productDetail.renge[0].saled_count <=
                      // productDetail.renge[0].to_count
                      +productDetail.renge[0].saled_count <
                      +productDetail.renge[0].to_count -
                        +productDetail.renge[0].from_count +
                        1
                        ? "active-progress_price-l"
                        : "deactive-progress_price"
                    }`}
                    >
                      {/* {addCommas(selected.price - selected.price * 0.25)} تومان */}
                      {/* <span>
                        {" "}
                        {addCommas(productDetail.renge[0].to_price)} تومان
                        
                      </span> */}
                      <span className="mx-auto">
                        {" "}
                        {addCommas(productDetail.renge[0].from_price)}تومان
                      </span>
                      {/* <span>{addCommas(selected.price)} تومان</span> */}
                    </div>
                  </>
                )}
                {/* second range */}
                {productDetail.renge.length > 1 && productType == 2 && (
                  <>
                    {" "}
                    <div
                      className={`sold-count d-flex justify-content-between align-items-center mt-1 mt-md-4 ${
                        // productDetail.renge[0].saled_count +
                        //   productDetail.renge[1].saled_count >=
                        //   productDetail.renge[1].from_count &&
                        // productDetail.renge[0].saled_count +
                        //   productDetail.renge[1].saled_count <
                        //   productDetail.renge[1].to_count
                        +productDetail.renge[1].saled_count >
                          +productDetail.renge[0].to_count -
                            +productDetail.renge[0].from_count +
                            1 &&
                        +productDetail.renge[1].saled_count <
                          +productDetail.renge[1].to_count -
                            +productDetail.renge[1].from_count +
                            1
                          ? "active-progress_active"
                          : "opacity-50"
                      }`}
                    >
                      <span>({productDetail.renge[1].to_count})</span>
                      <span>({productDetail.renge[1].from_count})</span>
                    </div>
                    <div
                      dir="ltr"
                      // style={{ backgroundColor: "#fff" }}
                      className="progress my-1"
                    >
                      <div
                        id="progress-bar"
                        className="progress-bar"
                        role="progressbar"
                        style={{
                          width: `${
                            // selected.sold < 201 && selected.sold > 100
                            //   ? String(selected.sold).slice(-2)
                            //   : 0
                            (+productDetail.renge[1].saled_count /
                              (+productDetail.renge[1].to_count -
                                +productDetail.renge[1].from_count +
                                1)) *
                            100
                          }% `,
                        }}
                        aria-valuenow="222"
                        aria-valuemin="101"
                        aria-valuemax="200"
                      >
                        {/* {selected.sold} */}
                        {productDetail.renge[1].saled_count}
                      </div>
                    </div>
                    <div
                      className={`d-flex justify-content-between align-items-center 
                  ${
                    // productDetail.renge[0].saled_count +
                    //   productDetail.renge[1].saled_count <
                    //   productDetail.renge[1].to_count &&
                    // productDetail.renge[0].saled_count +
                    //   productDetail.renge[1].saled_count >
                    //   productDetail.renge[1].to_count
                    +productDetail.renge[1].saled_count >
                      +productDetail.renge[0].to_count -
                        +productDetail.renge[0].from_count +
                        1 &&
                    +productDetail.renge[1].saled_count <
                      +productDetail.renge[1].to_count -
                        +productDetail.renge[1].from_count +
                        1
                      ? "active-progress_price-l"
                      : "deactive-progress_price"
                  }`}
                    >
                      {/* {addCommas(selected.price - selected.price * 0.5)} تومان */}

                      {/* <span>
                        {" "}
                        {addCommas(productDetail.renge[1].to_price)} تومان
                      </span> */}
                      <span className="mx-auto">
                        {" "}
                        {addCommas(productDetail.renge[1].from_price)}
                        تومان
                        {/* {addCommas(selected.price - selected.price * 0.25)} تومان */}
                      </span>
                    </div>
                  </>
                )}
                {/* third range */}
                {productDetail.renge.length > 2 && productType == 2 && (
                  <>
                    <div
                      className={`sold-count d-flex justify-content-between align-items-center mt-1 mt-md-4 ${
                        // productDetail.renge[0].saled_count +
                        //   productDetail.renge[1].saled_count +
                        //   productDetail.renge[2].saled_count >=
                        //   productDetail.renge[2].from_count &&
                        // productDetail.renge[0].saled_count +
                        //   productDetail.renge[1].saled_count +
                        //   productDetail.renge[2].saled_count <
                        //   productDetail.renge[2].to_count
                        +productDetail.renge[2].saled_count >
                          +productDetail.renge[1].to_count -
                            +productDetail.renge[1].from_count +
                            1 &&
                        +productDetail.renge[2].saled_count <
                          +productDetail.renge[2].to_count -
                            +productDetail.renge[2].from_count +
                            1
                          ? "active-progress_active"
                          : "opacity-50"
                      }`}
                    >
                      <span>({productDetail.renge[2].to_count})</span>
                      <span>({productDetail.renge[2].from_count})</span>
                    </div>
                    <div
                      dir="ltr"
                      // style={{ backgroundColor: "#fff" }}
                      className="progress my-1 "
                    >
                      <div
                        id="progress-bar"
                        className="progress-bar "
                        role="progressbar"
                        style={{
                          width: `${
                            // selected.sold > 200 ? String(selected.sold).slice(-2) : 0
                            (+productDetail.renge[2].saled_count /
                              (+productDetail.renge[2].to_count -
                                +productDetail.renge[2].from_count +
                                1)) *
                            100
                          }%`,
                        }}
                        aria-valuemin="201"
                        aria-valuemax="99999"
                      >
                        {/* {selected.sold} */}
                        {productDetail.renge[2].saled_count}
                      </div>
                    </div>
                    <div
                      className={`d-flex justify-content-between align-items-center 
                   ${
                     //  selected.sold > 200
                     //  productDetail.renge[0].saled_count +
                     //    productDetail.renge[1].saled_count +
                     //    productDetail.renge[2].saled_count <
                     //  productDetail.renge[2].from_count
                     +productDetail.renge[2].saled_count >
                       +productDetail.renge[1].to_count -
                         +productDetail.renge[1].from_count +
                         1 &&
                     +productDetail.renge[2].saled_count <
                       +productDetail.renge[2].to_count -
                         +productDetail.renge[2].from_count +
                         1
                       ? "active-progress_price-l"
                       : "deactive-progress_price"
                   }`}
                    >
                      <span>
                        {" "}
                        {/* {addCommas(productDetail.renge[2].to_price)}تومان */}
                        {/* {addCommas(selected.price - selected.price * 0.75)} تومان */}
                      </span>
                      <span className="mx-auto">
                        {" "}
                        {addCommas(productDetail.renge[2].from_price)}تومان
                        {/* {addCommas(selected.price - selected.price * 0.5)} تومان */}
                      </span>
                    </div>
                  </>
                )}
              </div>
            )
          }
        </div>
      </>

      {sameProduct != undefined && sameProduct.length > 0 && (
        <Swiper
          // loop={true}
          spaceBetween={10}
          // freeMode={true}
          watchSlidesProgress={true}
          modules={[FreeMode, Thumbs]}
          className="mySwiper"
          id="mobile-swiper"
          breakpoints={{
            300: { slidesPerView: 2 },
            400: { slidesPerView: 3 },
            580: { slidesPerView: 4 },
          }}
        >
          {sameProduct.map((item, index) => (
            <SwiperSlide
              key={index}
              onClick={() => {
                handleItem(item);
                selectedProduct(item.products_id, item.businesses_id);
              }}
            >
              <div
                className={`mobile-thumb-image-wrapper ${
                  selected.id === item.id ? "swiper-active" : "swiper-deactive "
                }`}
              >
                {item.img ? (
                  <img
                    style={{ borderRadius: "50%" }}
                    src={`http://marketgroup.tatdemo.ir/${item.img[0]?.url}`}
                  />
                ) : (
                  <img
                    // className="circle-image"
                    style={{ borderRadius: "50%" }}
                    // src={item.image}
                    src={`http://marketgroup.tatdemo.ir/${item.product[0]?.url}`}
                  />
                )}
              </div>
            </SwiperSlide>
          ))}
          {/* {discountedItems.map((item, index) => (
          <SwiperSlide key={index} onClick={() => handleItem(item)}>
            <div
              className={`mobile-thumb-image-wrapper ${
                selected === item ? "swiper-active" : "swiper-deactive "
              }`}
            >
              <img src={item.image} />
            </div>
          </SwiperSlide>
        ))} */}
        </Swiper>
      )}
    </>
  );
};

export default MobileCarousel;
